<!-- error message -->
<div *ngIf="isErrorMessage" class="alert alert-danger" role="alert">
    <div class="alignC">
        <i class="icon-error"></i>
        <p>{{'FRONT_USER.ERRORS_MESSAGES.ERROR' | translate}}</p>
        <p>{{'FRONT_USER.ERRORS_MESSAGES.InternalServerError' | translate}}</p>

    </div>
</div>
<div  *ngIf="!isErrorMessage">
    <h2 class="sectionTitle">{{ 'SHARED.REPORTS.RELEASE_REPORT.RELEASE_REPORT_NAME' | translate }}</h2>
    <div class="services-filter">
        <div class="form-container">
          <h4 class="section-title">{{ 'SHARED.Search' | translate}}</h4>
          <!-- Creation Date From -->
          <div class="form-group">
            <label
              for="txtCreationDateFrom">{{ 'SHARED.REPORTS.EBOOKING_REPORT.REQUEST_SUBMISSION_DATE_FROM' | translate}}</label>
            <input class="form-control" id="txtCreationDateFrom" name="txtCreationDateFrom" autocomplete="off"
              #input="bsDatepicker" [(ngModel)]="creationDateFrom" bsDatepicker [minDate]='null'
              [bsConfig]="{ dateInputFormat: 'DD-MM-YYYY' ,  minMode : hour}">
            <div class="red" *ngIf="showFromDateGreaterThanTodayDateMessage">
              {{'SHARED.REPORTS.EBOOKING_REPORT.FROM_DATE_GREATER_THAN_TODAY_DATE_MESSAGE' | translate}}
            </div>
            <div class="red" *ngIf="showFromDateGreaterThanToDateMessage">
              {{'SHARED.REPORTS.EBOOKING_REPORT.FROM_DATE_GREATER_THAN_TO_DATE_MESSAGE' | translate}}
            </div>
          </div>
          <!-- Creation Date To -->
          <div class="form-group">
            <label
              for="txtCreationDateTo">{{ 'SHARED.REPORTS.EBOOKING_REPORT.REQUEST_SUBMISSION_DATE_TO' | translate}}</label>
            <input class="form-control" id="txtCreationDateTo" name="txtCreationDateTo" autocomplete="off"
              #input="bsDatepicker" [(ngModel)]="creationDateTo" bsDatepicker [minDate]='null'
              [bsConfig]="{ dateInputFormat: 'DD-MM-YYYY' ,  minMode : hour}">
          </div>

           <!-- Service Type -->
          <div class="form-group">
            <label for="dllServiceType">{{'SHARED.REPORTS.RELEASE_REPORT.SERVICE_TYPE'| translate}}</label>
            <select [(ngModel)]="serviceTypeId" class="form-control" (change)="onServiceChange($event)">
                <option value="">--- {{'SHARED.AllServices' | translate}} ---</option>
                <ng-container *ngFor="let serviceTypeKey of serviceTypeKeys">
                <option [value]="serviceType[serviceTypeKey]">
                    {{serviceTypeKey}}
                </option>
                </ng-container>
            </select>
          </div>

          <!-- Request Status -->
          <div class="form-group">
            <label for="dllStatus">{{ 'SHARED.MYREQUESTS.Status' | translate}}</label>
            <select class="form-control" id="dllStatus" name="dllStatus" [(ngModel)]="statusId">
              <option value="">--- {{'SHARED.AllStatuses' | translate}} ---</option>
              <option *ngFor="let status of statusesList" value="{{status.Id}}">
                {{currentLanguage == "Ar" ? status.StatusAR : status.StatusEN}}
              </option>
            </select>
          </div>

          <!-- Longhaul Request Number -->
          <div class="form-group">
            <label for="txtRequestNumber">{{ 'SHARED.REPORTS.RELEASE_REPORT.LonghaulRequestNumber' | translate}}</label>
            <input type="text" class="form-control" [(ngModel)]="longhaulRequestNumber" autocomplete="off">
          </div>

          <!-- Request Number -->
          <div class="form-group">
            <label for="txtRequestNumber">{{ 'SHARED.REPORTS.RELEASE_REPORT.RequestNumber' | translate}}</label>
            <input type="text" class="form-control" [(ngModel)]="requestNumber" autocomplete="off">
          </div>
  
          <!-- Rebate File Number -->
          <div class="form-group">
            <label for="txtRebateFileNumber">{{ 'SHARED.REPORTS.RELEASE_REPORT.RebateFileNumber' | translate}}</label>
            <input type="text" class="form-control" [(ngModel)]="rebateFileNumber" autocomplete="off">
          </div>
  
          <!-- IMO -->
          <div class="form-group">
            <label for="txtImo">{{ 'SHARED.REPORTS.RELEASE_REPORT.IMO' | translate}}</label>
            <input type="text" class="form-control" [(ngModel)]="imo" autocomplete="off">
          </div>
  
          <!-- Vessel Name  -->
          <div class="form-group">
            <label for="txtShipName">{{ 'SHARED.REPORTS.RELEASE_REPORT.VesselName' | translate}}</label>
            <input type="text" class="form-control" [(ngModel)]="vesselName" autocomplete="off">
          </div>
  
          <!-- Agent Name  -->
          <div class="form-group">
            <label for="txtOperatorName">{{ 'SHARED.REPORTS.RELEASE_REPORT.AgentName' | translate}}</label>
            <input type="text" class="form-control" [(ngModel)]="agentName" autocomplete="off">
          </div>

          <!-- Release Form Creator -->
          <div class="form-group">
            <label for="ddlReleaseFormCreatorId">{{ 'SHARED.REPORTS.RELEASE_REPORT.ReleaseFormCreator' | translate}}</label>
            <select [(ngModel)]="releaseFormCreatorEmail" class="form-control" id="ddlReleaseFormCreatorId">
              <option value="" selected>{{'Choose'| translate}}</option>
              <option *ngFor="let releaseFormCreator of releaseFormCreators" [value]="releaseFormCreator?.Email">
                {{releaseFormCreator?.Username}}
              </option>
            </select>
          </div>
  
          <!-- Refund Date From -->
          <div class="form-group">
            <label
            for="txtRefundDateFrom">{{ 'SHARED.REPORTS.RELEASE_REPORT.RefundDateFrom' | translate}}</label>
            <input class="form-control" id="txtRefundDateFrom" name="txtRefundDateFrom" autocomplete="off"
            #input="bsDatepicker" [(ngModel)]="refundDateFrom" bsDatepicker [minDate]='null'
            [bsConfig]="{ dateInputFormat: 'DD-MM-YYYY' ,  minMode : hour}">
            <div class="red" *ngIf="showRefundFromDateGreaterThanRefundToDateMessage">
                {{'SHARED.REPORTS.RELEASE_REPORT.Refund_From_Date_Greater_Than_Refund_To_Date_Message' | translate}}
            </div>
          </div>

          <!-- Refund Date To -->
          <div class="form-group">
            <label
            for="txtRefundDateTo">{{ 'SHARED.REPORTS.RELEASE_REPORT.RefundDateTo' | translate}}</label>
            <input class="form-control" id="txtRefundDateTo" name="txtRefundDateTo" autocomplete="off"
            #input="bsDatepicker" [(ngModel)]="refundDateTo" bsDatepicker [minDate]='null'
            [bsConfig]="{ dateInputFormat: 'DD-MM-YYYY' ,  minMode : hour}">
          </div>  
        </div>

  
        <div class="btns-holder text-center">
          <input type="button" class="btn btn-primary SCAcustomBtn" (click)="getReleaseReportData()"
            value="{{ 'SHARED.Search' | translate}}" />
          <input type="button" class="btn btn-primary SCAcustomBtn" (click)="resetFilters()"
            value="{{ 'SHARED.ResetSearch' | translate}}" />
          <!-- <input type="button" *ngIf="!hideExportButton" class="SCAcustomBtn" (click)="EconomicExport()"
            value="{{ 'SHARED.REPORTS.EconomicExport' | translate}}" />
          <input type="button" *ngIf="!hideExportButton" class="SCAcustomBtn" (click)="MeasurementExport()"
            value="{{ 'SHARED.REPORTS.MeasurementExport' | translate}}" /> -->
         <!--   <input type="button" *ngIf="!hideExportButton" class="SCAcustomBtn" (click)="CloseRequests()"
            value="{{ 'SHARED.REPORTS.CloseRequests' | translate}}" />-->
        </div>
      </div>
    <app-grid-view #ReleaseReport [HasMenu]="HasMenu"></app-grid-view>
</div>
